import { PropsWithChildren } from 'react'

import { Button, Tooltip } from 'antd'

import { ActionProps } from '../interface'

export const Action = ({
  title,
  show,
  children,
  onClick
}: PropsWithChildren<ActionProps>) => {
  if (show === false) {
    return null
  }

  return (
    <Tooltip autoAdjustOverflow title={title}>
      <Button icon={children} type='default' onClick={onClick} />
    </Tooltip>
  )
}
